import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/* NgRx */
import { StoreModule } from '@ngrx/store';
import { reducer } from './state/user.reducer';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserComponent } from './user.component';
import { UserShellComponent } from './../user/containers/user-shell/user-shell.component';
import { UserLoginComponent } from './../user/components/user-login/user-login.component';

import { EffectsModule } from '@ngrx/effects';
import { UserEffects } from './state/user.effects';


@NgModule({
  declarations: [
    UserComponent,
    UserShellComponent,
    UserLoginComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule.forFeature('users', reducer),
    EffectsModule.forFeature([UserEffects])
  ],
  exports: [
    UserComponent,
    UserLoginComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class UserModule { 
  constructor(
  ){}

}
